import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Dialog, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CustomForm from '../Form';
import ErrorMessages from './ErrorMessages';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: '100%',
    padding: 16,
    backgroundColor: theme.palette.background.default
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  expansionPanel: {
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    borderBottom: '1px solid #DEDEDE',
    '&:before': {
      display: 'none'
    }
  },
  title: {
    marginTop: 20,
    marginBottom: 15
  },
  btn: {
    marginTop: 32
  }
}));

const TemplateWithDialog = (props) => {
  const {
    schemas,
    uiSchemas,
    handleChange,
    handleChangeForm,
    handleClickSubmit,
    expanded,
    errors,
    formData
  } = props;

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const history = useHistory();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    history.push('/template');
  };

  return (
    <Dialog fullScreen open={open}>
      <AppBar position='static' color='primary'>
        <Toolbar>
          <IconButton
            edge='start'
            onClick={handleClose}
            aria-label='close'
            color='inherit'
          >
            <CloseIcon />
          </IconButton>
          <Typography variant='h6' color='inherit'>
            {t('templateWithDialog:header')}
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid
        container
        direction='row'
        justify='space-between'
        alignContent='flex-start'
        className={classes.mainContainer}
      >
        <Grid container direction='row' alignContent='flex-start'>
          <ErrorMessages errors={errors} />
          <Grid item xs={12}>
            <Typography variant='h6' className={classes.title}>
              {t('templateWithDialog:header')}
            </Typography>
          </Grid>
          <Grid container>
            {schemas.map((objSchema, index) => (
              <Grid item xs={12} key={index}>
                <Accordion
                  key={`${index}_${objSchema.name}`}
                  expanded={expanded === objSchema.name}
                  onChange={handleChange(objSchema.name)}
                  classes={{
                    root: classes.expansionPanel
                  }}
                  square
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={classes.expansionPanelSummary}
                  >
                    <Typography variant='subtitle1'>
                      {objSchema.name}
                    </Typography>
                    {objSchema.message ? (
                      <div className={classes.column}>
                        <Typography className={classes.secondaryHeading}>
                          {t('templateWithDialog:mandatoryFields')}
                        </Typography>
                      </div>
                    ) : (
                      <div className={classes.column} />
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <CustomForm
                      formData={formData}
                      schema={objSchema.schema}
                      uiSchema={{
                        [objSchema.name]: uiSchemas[objSchema.name]
                      }}
                      onChange={handleChangeForm(objSchema.name)}
                    />
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Button
          fullWidth
          color='primary'
          type='submit'
          variant='contained'
          onClick={handleClickSubmit}
          className={classes.btn}
        >
          {t('templateWithDialog:save')}
        </Button>
      </Grid>
    </Dialog>
  );
};

TemplateWithDialog.propTypes = {
  schemas: PropTypes.array.isRequired,
  uiSchemas: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeForm: PropTypes.func.isRequired,
  handleClickSubmit: PropTypes.func.isRequired,
  expanded: PropTypes.string,
  errors: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired
};

export default TemplateWithDialog;
